import React from 'react';
import { Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import NavigationMenu from './NavigationMenu';

const Navigation = ({ isMenuOpen, setIsMenuOpen }) => {
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center" aria-label="Accueil Suro Phone" data-testid="nav-logo-link">
          <img
            src="https://customer-assets.emergentagent.com/job_fix-phone-fast-1/artifacts/wscem8ro_ChatGPT%20Image%2024%20f%C3%A9vr.%202026%2C%2022_17_46.png"
            alt="Logo Suro Phone - Réparation smartphone iPhone et Samsung à Saint-Chamond"
            className="h-10 md:h-12 w-auto" />
        </Link>

        <div className="hidden md:flex items-center gap-4">
          <a href="tel:0773601521" className="flex items-center gap-2 text-gray-700 hover:text-gray-900 transition-colors">
            <Phone className="w-5 h-5" />
            <span className="font-bold text-lg">07.73.60.15.21</span>
          </a>
        </div>

        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="flex flex-col gap-1.5 p-3 hover:bg-gray-100 rounded-lg transition-colors"
          aria-label="Menu"
          aria-expanded={isMenuOpen}
          data-testid="nav-menu-toggle"
        >
          <span className={`w-8 h-1 bg-gray-900 transition-all rounded-full ${isMenuOpen ? 'rotate-45 translate-y-2.5' : ''}`}></span>
          <span className={`w-8 h-1 bg-gray-900 transition-all rounded-full ${isMenuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`w-8 h-1 bg-gray-900 transition-all rounded-full ${isMenuOpen ? '-rotate-45 -translate-y-2.5' : ''}`}></span>
        </button>
      </div>

      {isMenuOpen && <NavigationMenu onClose={closeMenu} />}
    </nav>
  );
};

export default Navigation;
